import React, { useEffect, useRef, useState } from "react";
import {
  BottomButton,
  GuideBox,
  Layout,
  StickyContent,
  Title,
} from "../../components";
import styles from "./style.module.css";
import { black, gray5, gray6, mainColor, red, white } from "assets/styleUtils";
import { useNavigate } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  userSelectCounseling,
  userSelectDate,
  userSelectHall,
} from "recoil/atoms";
import { fetcher, post } from "utils/ApiUtil";
import { toast, ToastContainer } from "react-toastify";
import { ISendData } from "store/data/data";
import useUser from "hooks/useUser";
import { SvgCheckLine } from "assets";
import Lottie from "lottie-react";
import { loadingLottie } from "assets/lottie";
import { CertifyPhone } from "components/CertifyPhone";
import { userPhoneCodeSend } from "store/data/user";

const initAgreement = {
  privacy: false,
  solution: false,
  require: false,
  kakao: false,
};

type Agreement = typeof initAgreement;
type TAgreementKeys = keyof typeof initAgreement;

const agreementKeys = Object.keys(initAgreement) as TAgreementKeys[];

const agreements: {
  content: string;
  keys: TAgreementKeys;
  url: string;
  color: string;
}[] = [
  {
    content:
      "카톡 메세지의 [웨딩홀 접수완료] 버튼을 눌러주셔야 예약 완료됩니다.",
    url: "",
    keys: "kakao",
    color: red,
  },
  {
    content: "개인정보 수집 동의",
    url: "https://makemywedding.s3.ap-northeast-2.amazonaws.com/terms/1_makemywedding.pdf",
    keys: "privacy",
    color: black,
  },
  {
    content: "개인정보 제 3자 제공동의",
    url: "https://makemywedding.s3.ap-northeast-2.amazonaws.com/terms/2_makemywedding.pdf",
    keys: "solution",
    color: black,
  },
  {
    content: "필독 내용을 확인했으며 이에 동의합니다.",
    url: "",
    keys: "require",
    color: black,
  },
];

export const sendAuthCode = async ({
  setCodeCallback,
  bride_phone,
}: {
  setCodeCallback: (code: string) => void;
  bride_phone: string;
}) => {
  try {
    const code = Math.random().toFixed(10).substring(2, 6);
    setCodeCallback(code);
    const result = await userPhoneCodeSend({
      phone_number: bride_phone,
      code: code,
    });

    toast.success(
      result.message === "success" ? "전송되었습니다" : "다시 입력해주세요",
    );
    return code;
  } catch (error) {
    console.error("sendAuthCode error", error);
  }
};

const CounselingInfo = () => {
  const navigate = useNavigate();
  const { user, getUser } = useUser();
  const [selectArray, setSelectArray] = useRecoilState(userSelectHall);
  const weddingHallData = useRecoilValue(userSelectHall);
  const weddingDate = useRecoilValue(userSelectDate);
  const counselingDate = useRecoilValue(userSelectCounseling);
  //전송할 리코일 데이터 가공
  const list = (weddingHallData || []).map((hallItem) => ({
    contructor_no: hallItem.contructor_no,
    contructor_hall: hallItem.hall
      ? hallItem.hall.map((hallItem) => hallItem.no)
      : "",
  }));
  const [isSending, setIsSending] = useState(false);
  const priority1 = counselingDate && Object(counselingDate[0]);
  const priority2 = counselingDate && Object(counselingDate[1]);
  const priority3 = counselingDate && Object(counselingDate[2]);
  const priority4 = counselingDate && Object(counselingDate[3]);

  const wantToTime = weddingDate && Object(weddingDate).wantToTime;
  const wantToDay = weddingDate && Object(weddingDate).wantToDay;
  const wantToMonth = weddingDate && Object(weddingDate).wantToMonth;
  const wantToHeadCountOption =
    weddingDate && Object(weddingDate).wantToHeadCountOption;
  const wantTotHeadCount = weddingDate && Object(weddingDate).wantTotHeadCount;
  const HeadCountOptionText =
    weddingDate && Object(weddingDate).HeadCountOptionText;
  const wantWeddingHallName =
    weddingDate && Object(weddingDate).wantWeddingHallName;
  const wantWeddingHallType =
    weddingDate && Object(weddingDate).wantWeddingHallType;
  const extra_data = [
    {
      title: "희망 예식 월",
      category: "wantToWeddingDate",
      content: (wantToMonth || []).join(",") || "",
    },
    { title: "희망 예식 요일", content: (wantToDay || []).join(",") || "" },
    {
      title: "희망 예식 시간대",
      category: "wantToWeddingTime",
      content: [wantToTime || []][0] || "",
    },
    {
      title: "방문 상담 1순위",
      content: priority1.priority1 || "",
      category: "counselingDate",
    },
    {
      title: "방문 상담 2순위",
      content: priority2.priority2 || "",
      category: "counselingDate",
    },
    {
      title: "방문 상담 3순위",
      content: priority3.priority3 || "",
      category: "counselingDate",
    },
    {
      title: "방문 상담 시간 관련 특이사항",
      content: priority4.priority4 || "",
      category: "",
    },
    {
      title: "예식일 마감시 추가 일정",
      content: HeadCountOptionText || "",
    },
    {
      title: "예상 하객수",
      content: (wantTotHeadCount || [])[0] || "",
      category: "guaranteeCount",
    },
    {
      title: "미정 하객수",
      content: (wantToHeadCountOption || [])[0] || "",
      category: "guaranteeCount",
    },
    list.length === 0 && {
      title: "원하는 예식장소",
      content: wantWeddingHallName || "",
      category: "userInputVenue",
    },
    list.length === 0 && {
      title: "원하는 홀타입",
      content: wantWeddingHallType || "",
      category: "userInputHallType",
    },
  ];

  const [agreement, setAgreement] = useState<Agreement>({
    ...agreementKeys.reduce<Agreement>((acc, key) => {
      acc[key] = false;
      return acc;
    }, initAgreement),
  });
  //핸드폰 인증
  const [authCode, setAuthCode] = useState<string>();
  const isAuthCode = typeof authCode === "string";

  const [bride_name, setBrideName] = useState("");
  const [bride_phone, setBridePhone] = useState("");
  const [groom_name, setGroomName] = useState("");
  const [groom_phone, setGroomPhone] = useState("");

  const [existPhoneNum, setExistPhoneNum] = useState(false);
  const codeNumberRef = useRef<React.MutableRefObject<any> | null>(null);
  const changeUserPhoneNumber = (text: string) => {
    if (text === user?.phone_number) {
      setExistPhoneNum(true);
    } else {
      setExistPhoneNum(false);
      setBridePhone(text);
    }
  };
  const isAllAgreeTerms =
    Object.values(agreement).filter((agree) => !agree).length === 0;

  const isComplete =
    groom_phone.length === 11 &&
    bride_name.length > 1 &&
    groom_name.length > 1 &&
    bride_phone.match(/^01([0|1|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})$/) &&
    groom_phone.match(/^01([0|1|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})$/) &&
    !!isAllAgreeTerms &&
    !!existPhoneNum;

  useEffect(() => {
    setBrideName(user?.bride_name || "");
    setBridePhone(user?.phone_number || "");
    setGroomName(user?.groom_name || "");
    setGroomPhone(user?.groom_phone || "");
  }, []);

  const sendAllData = async () => {
    try {
      const { message, success } = await fetcher<ISendData>(
        "/api/user/addEstimate",
        {
          list,
          title: weddingHallData[0]?.name || "web문의",
          bride_name,
          bride_phone,
          groom_name,
          groom_phone,
          extra_data,
        },
      );

      if (success) {
        toast.success(message);
        setTimeout(() => {
          if (success) {
            setSelectArray([]);
            navigate("/");
          }
        }, 3000);
      }
    } catch (error) {
      console.error("send error", error);
      toast.error("관리자에게 문의해주세요");
    }
  };

  const sendAllDataAndNavigate = () => {
    if (!isSending) {
      setIsSending(true);
      sendAllData();
    }
  };

  useEffect(() => {
    if (user?.phone_number) {
      setExistPhoneNum(true);
    }
  }, []);

  return (
    <>
      {isSending ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "80vh",
            padding: 50,
          }}
        >
          <Lottie animationData={loadingLottie} loop={true} />
        </div>
      ) : (
        <>
          <div style={{ paddingBottom: "100px" }}>
            <Layout pdb={20} background={white}>
              <Title title="원활한 상담을 위해\n회원님의 정보가 필요합니다." />

              <div className={styles.inputForm}>
                <h4>기본 정보 입력</h4>
                <p>상담을 위해 필요한 정보이니 정확하게 기재해주세요.</p>

                <div className={styles.row}>
                  <div className={styles.colTitle}>신청자 정보</div>
                  <div className={styles.col}>
                    <div className={styles.inputCommon}>
                      <input
                        placeholder="이름 입력"
                        onChange={(e) => setBrideName(e.target.value)}
                        type="text"
                        value={bride_name}
                        style={{
                          height: "100%",
                          marginLeft: "8px",
                        }}
                      />
                    </div>
                    <div>
                      <div className={styles.row} style={{ width: "100%" }}>
                        <div
                          className={styles.inputCommon}
                          style={{ width: "70%" }}
                        >
                          <input
                            placeholder="전화번호 입력(- 제외)"
                            type="number"
                            onChange={(e) => {
                              const input = e.target;
                              const maxLength = 11;

                              if (input.value.length > maxLength) {
                                input.value = input.value.slice(0, maxLength);
                              }
                              setBridePhone(e.target.value);
                              changeUserPhoneNumber(input.value);
                            }}
                            value={bride_phone}
                            style={{
                              height: "100%",
                              marginLeft: "8px",
                            }}
                          />
                        </div>
                        <div
                          style={{
                            marginTop: 8,
                            marginLeft: 5,
                            width: 50,
                            fontSize: 12,
                            height: "35px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            color: existPhoneNum ? "green" : "red",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            if (!existPhoneNum) {
                              if (bride_phone?.length === 11) {
                                sendAuthCode({
                                  setCodeCallback: setAuthCode,
                                  bride_phone,
                                });
                              } else {
                                toast.error("휴대폰 번호를 확인해주세요");
                              }
                            }
                          }}
                        >
                          {existPhoneNum ? "인증됨" : "인증하기"}
                        </div>
                      </div>
                    </div>
                    <div className={styles.container}>
                      {isAuthCode && (
                        <CertifyPhone
                          bride_phone={bride_phone}
                          code={authCode}
                          setExistPhoneNum={setExistPhoneNum}
                          setAuthCode={setAuthCode}
                          width="70%"
                        />
                      )}
                    </div>
                  </div>
                </div>

                <div className={styles.row}>
                  <div className={styles.colTitle}>배우자 정보</div>
                  <div className={styles.col}>
                    <div className={styles.inputCommon}>
                      <input
                        placeholder="이름 입력"
                        onChange={(e) => setGroomName(e.target.value)}
                        type="text"
                        value={groom_name}
                        style={{
                          height: "100%",
                          marginLeft: "8px",
                        }}
                      />
                    </div>
                    <div className={styles.inputCommon}>
                      <input
                        placeholder="전화번호 입력(- 제외)"
                        type="number"
                        onChange={(e) => {
                          const input = e.target;
                          const maxLength = 11;

                          if (input.value.length > maxLength) {
                            input.value = input.value.slice(0, maxLength);
                          }
                          setGroomPhone(e.target.value);
                        }}
                        // ref={codeNumberRef}
                        value={groom_phone}
                        style={{
                          height: "100%",
                          marginLeft: "8px",
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              {agreements.map(({ content, url, keys, color }, i) => {
                return (
                  <div
                    key={i}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div
                      onClick={() =>
                        setAgreement({ ...agreement, [keys]: !agreement[keys] })
                      }
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          height: 40,
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            marginTop: "12px",
                            height: 30,
                            marginRight: 10,
                            cursor: "pointer",
                          }}
                        >
                          <SvgCheckLine
                            fill={agreement[keys] ? mainColor : gray6}
                          />
                        </div>
                        <div style={{ fontWeight: "500", color }}>
                          {content}
                        </div>
                      </div>
                    </div>
                    {!!url && (
                      <div
                        style={{ paddingLeft: 10 }}
                        onClick={() => {
                          navigate(`/PDFPage/${i}`);
                        }}
                      >
                        <img
                          style={{
                            width: 13,
                            height: 13,
                            cursor: "pointer",
                          }}
                          src={"/images/right.png"}
                          alt="Right Arrow"
                        />
                      </div>
                    )}
                  </div>
                );
              })}
            </Layout>

            <GuideBox
              title="*필독*"
              list={[
                "예약 문의를 주시면 순차적으로 업체 측과 확인 후 예약이 최종 확정됩니다.",
                "예약 완료 후 당일 취소/방문 노쇼/업체 연락 부재 및 미회신의 경우, 메이크마이웨딩과 업체 측 업무에 혼선을 주며 타 고객님들의 예약에도 영향을 미쳐 패널티가 부여됩니다. <br/><span>(패널티: 어플&베뉴 예약센터 이용 불가)</span>",
                "메이크마이웨딩을 통한 '최초' 예약일 경우에만 예약이 가능하며, 업체에 이미 연락하신 이력이 있으신 경우(타경로/타업체/직접 연락을 통한 예약, 카카오톡, 문자, 전화 등) 중복 접수로 요청 주신 내역 모두 접수되지 않습니다. 예약 후 취소하더라도 중복에 해당하여 메이크마이웨딩을 통한 예약 및 혜택 지급이 불가합니다.",
                "캐시백의 경우 웨딩홀에 따라 지급 조건이 상이하며, 제휴 상황에 따라 혜택 제공은 변동될 수 있습니다. 상담 시 안내 도와 드리겠습니다.",
                "웨딩홀 예약 접수는 '최대 5회'까지만 진행 가능합니다. 웨딩홀 예약 이후 취소하셔도 '예약 접수' 기준으로 카운팅되며 횟수 초과 시 메이크마이웨딩을 통한 추가 예약은 불가한 점 양해 부탁 드립니다.",
              ]}
            />
          </div>

          <StickyContent type="bottom">
            <BottomButton
              nextButtonDisabled={isComplete ? false : true}
              nextButtonText="완료"
              nextButtonEvent={() => {
                if (groom_name === bride_name) {
                  return toast.error("배우자와 신청자 이름이 달라야합니다.");
                } else if (groom_phone === bride_phone) {
                  return toast.error(
                    "배우자와 신청자 핸드폰 번호가 달라야합니다.",
                  );
                } else {
                  sendAllDataAndNavigate();
                }
              }}
            />
          </StickyContent>
        </>
      )}
      <ToastContainer
        position="bottom-center"
        limit={1}
        closeButton={false}
        autoClose={1000}
        theme="light"
      />
    </>
  );
};

export default CounselingInfo;
